
import { Component, Mixins } from 'vue-property-decorator';
import UboInfo from '@/app/components/ubos/UboInfo.vue';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import { BaseIndividual, ClientFileCategories, UploadedFile } from 'ah-api-gateways';
import { defaultAcceptanceFileTypes } from 'ah-common-lib/src/helpers/file';
import FileUploader from 'ah-common-lib/src/common/components/upload/FileUploader.vue';
import { useAuthStore } from '@/app/store/authModule';
import { tap } from 'rxjs/operators';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';

@Component({
  components: { UboInfo, FileUploader },
})
export default class UbosSettingsView extends Mixins(WithRequestManager) {
  private data: BaseIndividual[] = [];

  private defaultAcceptanceFileTypes = defaultAcceptanceFileTypes;

  created() {
    this.loadData();
  }

  loadData() {
    this.requestManager.newPromise(
      'loadClientUbos',
      this.individualSettingsStore.loadClientUbos(true).then((response) => (this.data = response || []))
    );
  }

  private get clientWithUbos() {
    return this.data.length > 0;
  }

  private get authStore() {
    return useAuthStore();
  }

  get individualSettingsStore() {
    return useIndividualSettingsStore();
  }

  private get clientId() {
    return this.authStore.loggedInIdentity!.client!.id;
  }

  private get resolutionLetter() {
    return (
      (this.individualSettingsStore.clientDocuments || []).find(
        (document) => document.category === ClientFileCategories.RESOLUTION_LETTER
      ) || null
    );
  }

  uploadFile(file: File) {
    return this.$services.client.uploadDocument(this.clientId, ClientFileCategories.RESOLUTION_LETTER, file).pipe(
      tap((update) => {
        if (update.finished) {
          this.$services.client.getDocuments(this.clientId).subscribe((docs) => {
            const document = docs.find((d) => d.id === update.file.id);

            if (document) {
              this.individualSettingsStore.setClientDocument({ document });
            }
          });
        }
      })
    );
  }

  deleteFile(file: UploadedFile) {
    return this.$services.client.deleteDocument(this.clientId, file.id).pipe(
      tap(() => {
        this.individualSettingsStore.unsetClientDocument({ category: file.category as ClientFileCategories });
      })
    );
  }

  downloadFile(file: UploadedFile) {
    return this.$services.client.downloadSyncDocument(this.clientId, file);
  }
}
